export default function isURLSameOrigin(): boolean {
  return true;
}
